<!-- /* [NT-APPLY-PER-POP] 개인회원 매칭신청 */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      disabledFooter
      title="매칭 신청하기"
      v-if="data"
    >
      <div class="popupViewProfile">
        <UserInfoCard :data="data" />

        <MatchingProcessItems />
        <section>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <h3 class="matchingHeadLine">신청서 작성</h3>
              <div style="margin-bottom: 50px;">
                <ValidationProvider
                  name="신청 대상 회원"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <InputField
                    label="신청 대상 회원"
                    v-model="data.name"
                    :errors="errors"
                    readonly
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="매칭신청 사유"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    v-model="form.requestReason"
                    :errors="errors"
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">연락처 정보</h3>
                <InputField label="신청자 이름" v-model="user.name" readonly />
                <InputField label="이메일 주소" v-model="user.email" readonly />
                <InputField
                  label="전화번호"
                  v-model="user.phoneNumber"
                  readonly
                />
              </div>

              <div class="modal-action">
                <MainButton
                  :disabled="disabledSubmit"
                  btnText="신청서 작성"
                  type="submit"
                />
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import MatchingProcessItems from "@/components/items/MatchingProcessItems.vue";
import InputField from "@/components/formControl/InputField.vue";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";

export default {
  name: "PopupMatchingRequest",
  components: {
    BasicModal,
    MainButton,
    MatchingProcessItems,
    ValidationObserver,
    ValidationProvider,
    InputField,
    TextAreaInputField,
    UserInfoCard,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    data: Object,
  },
  data() {
    return {
      user: this.$store.state.auth.user,
      disabledSubmit: false,
      form: {},
    };
  },
  methods: {
    onClickSubmitForm() {
      var that = this;
      this.disabledSubmit = true;
      this.$store
        .dispatch("directMatching/createDirectMatching", {
          requesterIdx: this.user.idx,
          requestedIdx: this.data.idx,
          requestReason: this.form.requestReason,
        })
        .then((response) => {
          if (response.status == 200) {
            if (that.handleToggleModal) that.handleToggleModal();
            that.$alert("알림", "제출해주셔서 감사합니다");
          } else {
            that.$alert("Error", response.error?.message, "error");
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          that.disabledSubmit = false;
          if (that.handleToggleModal) that.handleToggleModal();
        });
    },
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.itemRow {
  display: flex;
  align-items: flex-end;
  border: 1px solid #ababab;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  .itemRowText {
    padding-left: 16px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
  }
}
</style>
